<template>
    <div>
        <div v-show="isActive" :class="{ 'active': isActive }">
            <slot :next-tab="nextTab" :prev-tab="prevTab"></slot>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Tab',

    props: {
        name: {
            type: String,
            required: true,
        },
        active: {
            type: Boolean,
            default: false,
        },
        hasErrors: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isActive: this.active,
        };
    },

    methods: {
        select() {
            this.isActive = true;

            this.$events.$emit('update-active-tab', this);
        },

        nextTab() {
            this.$events.$emit('next-tab');
        },

        prevTab() {
            this.$events.$emit('prev-tab');
        },
    },
};

</script>
